import f from "../../funcs";
import Api from "./Api";
import RowsStorage from "../storage/RowsStorage";


let FormApi = Api.extend("FormApi", {
    _entity: "form"
});

FormApi.prototype.init = function(params) {
    FormApi.__super__.init.apply(this, arguments);
    this.form = params.form;
};

FormApi.prototype.submit = function(data, callback) {
    if ( !f.isFunction(callback) ) {
        callback = function() {};
    }

    data = f.deepClone(data);
    let tableName = this.form.table;
    let id = this.form.id;

    let table = RowsStorage.get(tableName);
    this.saveProxyChanges(function() {
        table.update(id, data, function(err, model) {
            if ( err ) {
                callback(err, { status: "error", code: "update_error" });
            } else {
                let row = f.deepClone(model.attributes);
                callback(null, {
                    status: "success",
                    row
                });
            }
        });
    });
};

FormApi.prototype.loadRow = function(id, callback) {
    RowsStorage.get(this.form.table).get(id, function(err, model) {
        let row;
        if ( !err && model ) {
            row = f.deepClone(model.attributes);
        }
        callback(err, row);
    });
};

FormApi.prototype.saveProxyChanges = function(callback) {
    let iterations = [];
    this.form.editor.proxies.map(function(proxy) {
        let model = proxy.model;
        let tableName = proxy.table;
        let storage = RowsStorage.get(tableName);
        let changes = proxy.changes;

        if ( Object.keys(changes).length === 0 ) {
            return;
        }

        iterations.push(
            storage.update.bind(storage, model.id, changes)
        );
    });

    f.parallel(iterations, callback);
};

export default FormApi;
